import React, { useEffect, useRef, useState } from "react";
import {
  Drawer,
  TextField,
  IconButton,
  Button,
  Box,
  Typography,
  Paper,
  Avatar,
  Tooltip,
  CircularProgress,
  Dialog,
  DialogContent,
} from "@mui/material";
import logo from "../assets/images/logo.png";
import ReactMarkdown from "react-markdown";
import MicIcon from "@mui/icons-material/Mic";
import MicOffIcon from "@mui/icons-material/MicOff";
import SendIcon from "@mui/icons-material/Send";
import DeleteIcon from "@mui/icons-material/Delete";
import { useSpring, animated } from "react-spring";
import { generateGuidenceOnView } from "../store/slices/guide/guideOnViewSlice";
import { useDispatch, useSelector } from "react-redux";
import ChatLoader from "./chatLoader";
import getuserData from "../utils/userData";
import { generateGuidenceOnFeedback } from "../store/slices/guide/guideOnFeedback";
import { generateVoiceExplanation } from "../store/slices/guide/generateVoice";
import {
  FaChevronDown,
  FaRegCirclePlay,
  FaRegCircleStop,
} from "react-icons/fa6";
import { HiSpeakerWave } from "react-icons/hi2";
import { RiCloseFill } from "react-icons/ri";
import { FaChevronUp } from "react-icons/fa";
import { fetchSettings } from "../store/slices/settings/fetchSettings";
import { useSpeechSynthesis } from "react-speech-kit";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import { fetchUserById } from "../store/slices/users/userByIdSlice";
import { toast } from "react-toastify";

const ChatFeedbackPageDrawer = ({
  open,
  setOpen,
  data,
  module,
  questionType,
}) => {
  const dispatch = useDispatch();
  const [messages, setMessages] = useState([]);
  const navigate = useNavigate();


  const [audioCache, setAudioCache] = useState({}); // Cache for audio URLs
  const [isLoading, setIsLoading] = useState(false); // Track loading state
  const [playingText, setPlayingText] = useState(null); // Track the currently playing text
  const [currentAudio, setCurrentAudio] = useState(null);
  const settings = useSelector((state) => state.settings.settings);
  const [load, setLoad] = useState(false);
  const user = getuserData();
  const [userInput, setUserInput] = useState("");
  const userState = useSelector((state) => state.userById.user);
  const [isSubscribed, setisSubscribed] = useState(false);
  const [hasValidPlan, sethasValidPlan] = useState(false);
  const [subscription, setSubscription] = useState("");
  const listOfPlans = ["tutor_monthly", "tutor_six_monthly", "tutor_yearly"];

  const [isListening, setIsListening] = useState(false);
  const recognitionRef = useRef(null);
  const [selectedQuestion, setSelectedQuestion] = useState(
    module === "Essay" ? true : false
  ); // To store the selected question

  const [predefinedQuestions, setpredefinedQuestions] = useState([]);

  const setDefaultQuestions = () => {
    if (module === "Essay") {
      setpredefinedQuestions(
        settings?.settings?.predefined_questions?.essay_feedback_guide
      );
    } else {
      setpredefinedQuestions(
        settings?.settings?.predefined_questions
          ?.grammar_comprehension_feedback_guide
      );
    }
  };
  useEffect(() => {
    setDefaultQuestions();
  }, [settings]);
  useEffect(() => {
    dispatch(fetchSettings());
  }, []);

  const [animationProps, setanimationProps] = useState({
    from: { opacity: 0, transform: "translateY(20px)" },
    to: { opacity: 1, transform: "translateY(0px)" },
    config: { tension: 200, friction: 20 },
  });
  const handleSend = async (question) => {
    if (!isSubscribed) {
      toast.error(
        <>
          You have no free Guide interactions left.{" "}
          <span
            style={{ fontWeight: "bold", cursor: "pointer" }}
            onClick={() => navigate(`/my-plan`)}
          >
            &nbsp;(Upgrade Plan)
          </span>
        </>,
        { closeOnClick: true }
      );

      return;
    }
    const userMessage = question || userInput;

    if (module === "Essay") {
      // Add the user's message to the chat with animation triggered for a new message
      if (!userMessage.trim()) return;
      setMessages((prev) => [...prev, { type: "user", text: userMessage }]);
    } else {
      if (!userMessage.trim()) return;
      setMessages((prev) => [
        ...prev,
        {
          type: "user",
          text: (
            <>
              <div>
                <strong>
                  Q{selectedQuestion.id}: {selectedQuestion.question}
                </strong>
              </div>
              <br />
              <div>
                <strong>You :</strong> {userMessage}
              </div>
            </>
          ),
        },
      ]);
      // setSelectedQuestion(null); // Reset selected question after sending
    }

    // Mark the message as new and trigger animation
    // setIsNewMessage(true);
    setUserInput(""); // Clear input after sending

    // Call API and add the response
    try {
      setLoad(true);
      let response;
      if (module === "Essay") {
        response = await dispatch(
          generateGuidenceOnFeedback(
            {
              id: data?.attempt?.exam_id, // Replace with actual id
              user_instruction: userMessage,
              user_answer: data?.attempt?.response,
              practice_set_question: data?.attempt?.question,
              specific_section: data?.feedback,
            },
            module?.toLowerCase()
          )
        );
      } else {
        if (questionType === "mcq") {
          const selectedAnswerText = selectedQuestion?.options.find(
            (option) => option.id === selectedQuestion.selected_option
          )?.text;

          const correctAnswerText = selectedQuestion?.options.find(
            (option) => option.id === selectedQuestion.correct_option
          )?.text;
          response = await dispatch(
            generateGuidenceOnFeedback(
              {
                id:
                  module === "Comprehension"
                    ? data?.attempt?.comprehension_id
                    : data?.attempt?.grammar_rule_id, // Replace with actual id
                user_instruction: userMessage,
                practice_set_question:
                  data?.paragraph + "\n\n\n\n" + selectedQuestion?.question,
                user_answer: selectedAnswerText,
                correct_answer: correctAnswerText,
                feedback: selectedQuestion?.feedback,
                // specific_section:selectedQuestion?.
              },
              module?.toLowerCase()
            )
          );
        } else {
          response = await dispatch(
            generateGuidenceOnFeedback(
              {
                id:
                  module === "Comprehension"
                    ? data?.attempt?.comprehension_id
                    : data?.attempt?.grammar_rule_id, // Replace with actual id
                user_instruction: userMessage,
                practice_set_question: selectedQuestion?.question,
                user_answer: selectedQuestion?.entered_answer,
                feedback: selectedQuestion?.feedback,
                // specific_section:selectedQuestion?.
              },
              module?.toLowerCase()
            )
          );
        }
      }
      setpredefinedQuestions(response?.data?.potential_questions);
      setMessages((prev) => [
        ...prev,
        { type: "bot", text: response?.data || "No response generated" },
      ]);
      setLoad(false);
    } catch (error) {
      setMessages((prev) => [
        ...prev,
        { type: "bot", text: "Error fetching response. Try again." },
      ]);
      setLoad(false);
    }

    // Reset the animation trigger flag after message is sent
    // setIsNewMessage(false);
  };

  const generateVoice = async (text) => {
    if (audioCache[text]) {
      // Play cached audio
      handlePlayAudio(audioCache[text], text);
    } else {
      setIsLoading(true); // Start loading
      try {
        const response = await dispatch(generateVoiceExplanation({ text }));
        const blob = response.data; // Assuming the API returns a Blob
        const audioUrl = URL.createObjectURL(blob);

        // Cache the generated audio
        setAudioCache((prev) => ({ ...prev, [text]: audioUrl }));

        // Play the newly generated audio
        handlePlayAudio(audioUrl, text);
      } catch (error) {
        console.error("Error generating voice:", error);
      } finally {
        setIsLoading(false); // Stop loading
      }
    }
  };

  const handlePlayAudio = (audioUrl, text) => {
    if (currentAudio) {
      currentAudio.pause(); // Stop any currently playing audio
      currentAudio.currentTime = 0; // Reset current audio
    }

    const audio = new Audio(audioUrl);
    setCurrentAudio(audio);
    setPlayingText(text);

    audio.play();

    // Reset playing state when audio ends
    audio.onended = () => {
      setPlayingText(null);
      setCurrentAudio(null);
    };
  };

  const handleStopAudio = () => {
    if (currentAudio) {
      currentAudio.pause();
      currentAudio.currentTime = 0; // Reset the audio to the start
      setPlayingText(null);
      setCurrentAudio(null);
    }
  };

  const clearChat = () => {
    setMessages([]);
    setSelectedQuestion(null); // Reset selected question when clearing chat
    setDefaultQuestions();
  };

  const Message = ({ type, text }) => {
    const [textHeight, setTextHeight] = useState(0);
    const [isExpanded, setIsExpanded] = useState(false); // Track if the message is expanded
    const textRef = useRef(null); // Reference for calculating height

    // Determine if the text is too long
    const isLongText =
      type !== "user" &&
      typeof text === "string" &&
      text.split(" ").length > 100;

    // Truncate the text for preview if necessary
    const truncatedText =
      isLongText && !isExpanded
        ? text.split(" ").slice(0, 100).join(" ") + "..."
        : text;

    useEffect(() => {
      if (textRef.current) {
        setTextHeight(textRef.current.scrollHeight); // Get the actual content height
      }
    }, [truncatedText]);

    return (
      <animated.div>
        <Paper
          elevation={3}
          sx={{
            padding: "10px 15px",
            margin: "10px 0",
            maxWidth:
              module === "Essay" && type === "user"
                ? "fit-content"
                : "calc(700px - 89px) !important",
            alignSelf: type === "user" ? "end" : "start",
            backgroundColor: type === "user" ? "#fff0dc" : "#eef7fe",
            borderRadius:
              type === "user" ? "20px 20px 20px 0" : "0 20px 20px 20px",
          }}
        >
          {/* Render the content based on type */}
          {type === "user" ? (
            text // Render JSX/HTML content directly
          ) : (
            <div
              ref={textRef}
              style={{
                overflow: "hidden",
                maxHeight: isExpanded ? `${textHeight}px` : "400px", // Expand to full height or limit to 400px
                paddingBottom: isExpanded ? "20px" : "0px", // Add padding when expanded
                transition: "max-height 0.7s ease, padding-bottom 0.7s ease",
              }}
            >
              <ReactMarkdown>{truncatedText}</ReactMarkdown>
            </div>
          )}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              marginTop: type === "bot" ? 1 : 0,
            }}
          >
            {/* Show additional controls for bot messages */}
            {type === "bot" && (
              <>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                    alignItems: "center",
                  }}
                >
                  {/* Audio Button */}
                  <Tooltip title="Read aloud" arrow>
                    <IconButton
                      sx={{
                        padding: "0 !important",
                        width: "20px",
                      }}
                      onClick={() =>
                        audioCache[text]
                          ? playingText === text
                            ? handleStopAudio()
                            : handlePlayAudio(audioCache[text], text)
                          : generateVoice(text)
                      }
                      disabled={isLoading}
                    >
                      {isLoading ? (
                        <CircularProgress size={20} sx={{ color: "#fff" }} />
                      ) : playingText === text ? (
                        <FaRegCircleStop fill="#2090b7" />
                      ) : (
                        <HiSpeakerWave fill="#1d86ab" />
                      )}
                    </IconButton>
                  </Tooltip>

                  {/* Expand/Collapse Button for Long Text */}
                  {isLongText && (
                    <Box sx={{ textAlign: "end" }}>
                      <Button
                        size="small"
                        onClick={() => setIsExpanded(!isExpanded)}
                        sx={{
                          textTransform: "none",
                          color: "#1d86ab",
                          fontWeight: "bold",
                          fontSize: "0.80rem",
                          display: "flex",
                          alignItems: "center",
                          gap: "5px",
                        }}
                      >
                        <span
                          style={{
                            display: "inline-block",
                            transform: isExpanded
                              ? "rotate(180deg)"
                              : "rotate(0deg)", // Rotate the icon
                            transition: "transform 0.3s ease", // Smooth icon rotation
                          }}
                        >
                          <FaChevronDown fill="#1d86ab" />
                        </span>
                        {isExpanded ? "Show Less" : "Show More"}
                      </Button>
                    </Box>
                  )}
                </Box>
              </>
            )}
          </Box>
        </Paper>
      </animated.div>
    );
  };

  useEffect(() => {
    if ("webkitSpeechRecognition" in window || "SpeechRecognition" in window) {
      const SpeechRecognition =
        window.SpeechRecognition || window.webkitSpeechRecognition;
      const recognition = new SpeechRecognition();
      recognition.lang = "en-US";
      recognition.interimResults = false; // Only process final results
      recognition.continuous = false;

      recognition.onresult = (event) => {
        const transcript = event.results[0][0].transcript; // Only take the final transcript
        setUserInput((prevInput) => `${prevInput.trim()} ${transcript}`.trim());
      };

      recognition.onend = () => {
        setIsListening(false);
      };

      recognitionRef.current = recognition;
    } else {
      alert("Speech Recognition is not supported in this browser.");
    }
  }, []);

  const handleStartListening = () => {
    setUserInput("");
    if (recognitionRef.current) {
      setIsListening(true);
      recognitionRef.current.start();
    }
  };

  const handleStopListening = () => {
    if (recognitionRef.current) {
      recognitionRef.current.stop();
      setIsListening(false);
    }
  };

  useEffect(() => {
    const userData = Cookies.get("userData");
    if (userData) {
      // Parse the retrieved string back into an object
      const parsedUserData = JSON.parse(userData);
      setSubscription(parsedUserData.activePlan);
    } else {
      console.error("No userData found in cookies");
    }
  }, []);

  useEffect(() => {
    // If no subscription, check comprehension practice

    if (!subscription) {
      if (userState?.ai_interactions_left <= 0) {
        setisSubscribed(false);

        return;
      } else {
        setisSubscribed(userState?.ai_interactions_left > 0);
        return;
      }
    }
    // Check if the subscription includes any valid plans
    const validPlan =
      subscription && listOfPlans?.some((plan) => subscription.includes(plan));
    sethasValidPlan(validPlan);
    if (!validPlan) {
      if (userState?.ai_interactions_left <= 0) {
        setisSubscribed(false);

        return;
      } else {
        setisSubscribed(userState?.ai_interactions_left > 0);
        return;
      }
    }
    setisSubscribed(!!validPlan);
  }, [subscription, userState]);

  useEffect(() => {
    if (userState) {
      dispatch(fetchUserById(userState?.id, "guide"));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [messages]);

  return (
    <>
      <Drawer
        anchor="right"
        open={open}
        onClose={() => setOpen(false)}
        className="chat-drawer"
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            height: "100%",
          }}
        >
          {/* Header */}
          <Box
            sx={{
              padding: "16px",
              backgroundColor: "#2090b7",
              color: "#fff",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <Typography sx={{ color: "white !important", fontSize: "22px" }}>
                OpenEssayMe {module} Guide
              </Typography>
              {(!subscription || (subscription && !hasValidPlan)) && (
                <Tooltip
                  componentsProps={{
                    tooltip: {
                      sx: {
                        backgroundColor: "#fff",
                        color: "#000",
                        fontSize: "14px",
                        padding: "10px",
                        borderRadius: "8px",
                        boxShadow: "0px 4px 10px rgba(0,0,0,0.2)",
                      },
                    },
                    arrow: {
                      sx: {
                        color: "#fff", // Same color as the tooltip background
                      },
                    },
                  }}
                  title={
                    <Box>
                      <Typography variant="body2">
                        You have{" "}
                        <span style={{ fontWeight: "bold", color: "#2090b7" }}>
                          {userState?.ai_interactions_left}
                        </span>{" "}
                        out of{" "}
                        <span style={{ fontWeight: "bold", color: "#2090b7" }}>
                          14
                        </span>{" "}
                        free Guide interactions left.
                      </Typography>
                      <Typography variant="body2" mt={1}>
                        Unlock more with our{" "}
                        <span
                          style={{ fontWeight: "bold", cursor: "pointer" }}
                          onClick={() => navigate(`/my-plan`)}
                        >
                          Premium Plans
                        </span>
                        .
                      </Typography>
                    </Box>
                  }
                  arrow
                >
                  <Box
                    sx={{
                      position: "relative",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: 31,
                      height: 31,
                      borderRadius: "50%",
                      background: "rgb(214, 247, 255)",
                      backdropFilter: "blur(6px)",
                      // ...glowEffect, // Add glow if low attempts
                    }}
                  >
                    {/* Circular Progress with Dynamic Color */}
                    <CircularProgress
                      variant="determinate"
                      value={(userState?.ai_interactions_left / 14) * 100}
                      size={31}
                      thickness={5}
                      sx={{
                        "& .MuiCircularProgress-circle": {
                          stroke:
                            userState?.ai_interactions_left > 8
                              ? "#0d5f79 !important"
                              : userState?.ai_interactions_left > 3
                              ? "#fd8300 !important"
                              : "#e70202 !important", // Change stroke color here
                        },
                      }}
                    />

                    {/* Attempts Left Number */}
                    <Typography
                      variant="body1"
                      sx={{
                        position: "absolute",
                        fontWeight: "bold",
                        color:
                          userState?.ai_interactions_left > 8
                            ? "#176f8b !important"
                            : userState?.ai_interactions_left > 3
                            ? "#fd8300 !important"
                            : "#e70202 !important",
                        fontSize:
                          userState?.ai_interactions_left > 9 ? "14px" : "15px",
                      }}
                    >
                      {userState?.ai_interactions_left}
                    </Typography>
                  </Box>
                </Tooltip>
              )}
            </Box>
            <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <Button
                size="small"
                variant="outlined"
                sx={{ color: "#fff", borderColor: "#fff" }}
                onClick={clearChat}
              >
                Clear Chat
              </Button>

              <IconButton onClick={() => setOpen(false)}>
                <RiCloseFill fill="white" />
              </IconButton>
            </Box>
          </Box>

          {/* Chat Messages */}
          <Box
            sx={{
              flexGrow: 1,
              padding: "16px",
              overflowY: "auto",
              display: "flex",
              flexDirection: "column",
            }}
          >
            {messages?.map((msg, index) => (
              <Box sx={{ display: "flex", gap: "10px" }} key={index}>
                <Avatar
                  src={msg.type === "user" ? user?.profileImg : logo}
                  sx={{
                    backgroundColor: msg.type === "user" ? "none" : "#1c2536",
                    marginTop: "10px",
                  }}
                />
                <Message
                  type={msg.type}
                  text={msg.type === "user" ? msg.text : msg.text.text_response}
                />
              </Box>
            ))}
            {load && <ChatLoader />}
            {/* {module === "Essay" && ( */}
            <Box sx={{ mt: 3 }}>
              {messages?.length > 1 &&
                !load &&
                predefinedQuestions?.map((question, index) => (
                  <Button
                    key={index}
                    variant="outlined"
                    sx={{
                      color: "#2090b7",
                      borderRadius: "15px",
                      fontWeight: 600,
                      borderColor: "#2090b7",
                      margin: "5px",
                      "&:hover": {
                        backgroundColor: "#2090b7",
                        color: "white",
                      },
                      textTransform: "none",
                      fontSize: "14px",
                      textAlign: "left",
                    }}
                    size="small"
                    onClick={() => handleSend(question)}
                  >
                    {question}
                  </Button>
                ))}
            </Box>
            {/* )} */}
          </Box>

          {/* Select Question */}

          <Box>
            {module === "Essay" ? (
              <>
                {/* Predefined Questions */}
                {messages?.length === 0 && (
                  <Box sx={{ padding: "16px", borderTop: "1px solid #ddd" }}>
                    <Typography variant="subtitle1">
                      Quick Questions:
                    </Typography>
                    <Box
                      sx={{
                        display: "flex",
                        gap: "8px",
                        flexWrap: "wrap",
                        marginTop: "8px",
                      }}
                    >
                      {predefinedQuestions?.map((question, index) => (
                        <Button
                          key={index}
                          variant="contained"
                          sx={{
                            backgroundColor: "#2090b7",
                            "&:hover": { backgroundColor: "#2090b7" },
                            textTransform: "none",
                            fontSize: "14px",
                          }}
                          size="small"
                          onClick={() => handleSend(question)}
                        >
                          {question}
                        </Button>
                      ))}
                    </Box>
                  </Box>
                )}
              </>
            ) : (
              <Box
                sx={{
                  padding: "16px",
                  borderTop: !load ? "1px solid #ddd" : "none",
                }}
              >
                {messages?.length === 0 && selectedQuestion && (
                  <Box sx={{}}>
                    <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                      Quick Questions:
                    </Typography>
                    <Box
                      sx={{
                        display: "flex",
                        gap: "8px",
                        flexWrap: "wrap",
                        marginTop: "8px",
                      }}
                    >
                      {predefinedQuestions?.map((question, index) => (
                        <Button
                          key={index}
                          variant="contained"
                          sx={{
                            backgroundColor: "#2090b7",
                            "&:hover": { backgroundColor: "#2090b7" },
                            textTransform: "none",
                            fontSize: "14px",
                          }}
                          size="small"
                          onClick={() => handleSend(question)}
                        >
                          {question}
                        </Button>
                      ))}
                    </Box>
                  </Box>
                )}{" "}
                {!load &&
                  (data?.feedback?.length > 0 ? (
                    <>
                      <Typography
                        variant="subtitle1"
                        sx={{
                          fontWeight: 600,
                          mt: messages?.length === 0 ? 1 : 0,
                        }}
                      >
                        Select a Question:
                      </Typography>
                      <Box
                        sx={{
                          display: "flex",
                          gap: "8px",
                          flexWrap: "wrap",
                          marginTop: "8px",
                        }}
                      >
                        {data?.feedback?.map((item) => (
                          <Tooltip
                            key={item.id}
                            title={item.question}
                            placement="top"
                            arrow
                          >
                            <Button
                              variant="contained"
                              sx={{
                                backgroundColor:
                                  selectedQuestion?.id === item.id
                                    ? "#003a74"
                                    : "#2090b7",
                                fontWeight:
                                  selectedQuestion?.id === item.id ? 600 : 500,
                                "&:hover": { backgroundColor: "#2090b7" },
                              }}
                              size="small"
                              onClick={() => setSelectedQuestion(item)}
                            >
                              {item.id} {/* Display only the ID */}
                            </Button>
                          </Tooltip>
                        ))}
                      </Box>
                    </>
                  ) : (
                    <Typography sx={{ fontWeight: 600 }}>
                      You can ask the guide once the Feedback is generated
                    </Typography>
                  ))}
              </Box>
            )}
          </Box>
          {/* )} */}

          {/* Input Area */}
          {(module === "Essay" || selectedQuestion) && !load && (
            <Box
              sx={{
                padding: "16px",
                display: "flex",
                alignItems: "center",
              }}
            >
              <TextField
                fullWidth
                size="small"
                placeholder="Ask the Guide..."
                value={userInput}
                onChange={(e) => setUserInput(e.target.value)}
                onKeyPress={(e) => {
                  if (e.key === "Enter") {
                    handleSend(null);
                  }
                }}
              />
              <Tooltip title="Voice input" arrow>
                <IconButton
                  onClick={
                    isListening ? handleStopListening : handleStartListening
                  }
                  sx={{ marginRight: "8px" }}
                >
                  {isListening ? <MicOffIcon color="error" /> : <MicIcon />}
                </IconButton>
              </Tooltip>
              <Tooltip title="Send" arrow>
                <IconButton onClick={() => handleSend(null)}>
                  <SendIcon />
                </IconButton>
              </Tooltip>
            </Box>
          )}
        </Box>

        {/* Animated Speak Prompt inside Drawer */}
        {isListening && (
          <Box
            sx={{
              position: "absolute",
              bottom: "10%",
              left: "50%",
              transform: "translateX(-50%)",
              textAlign: "center",
              backgroundColor: "rgb(235, 235, 235)",
              color: "black",
              padding: "16px 30px",
              borderRadius: "8px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "12px",
              boxShadow:
                "0px 5px 9px  rgba(1, 1, 1, 0.5), 0px 1px 3px rgba(0, 0, 0, 0.06)",
            }}
          >
            <Typography color="inherit" sx={{ fontWeight: 600 }}>
              Listening...
            </Typography>
            <Box
              sx={{
                display: "flex",
                gap: "4px",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Box
                sx={{
                  width: "7px",
                  height: "7px",
                  backgroundColor: "primary.main",
                  borderRadius: "50%",
                  animation: "bounce 1.2s infinite ease-in-out",
                }}
              />
              <Box
                sx={{
                  width: "8px",
                  height: "8px",
                  backgroundColor: "primary.main",
                  borderRadius: "50%",
                  animation: "bounce 1.2s infinite ease-in-out",
                  animationDelay: "0.2s",
                }}
              />
              <Box
                sx={{
                  width: "7px",
                  height: "7px",
                  backgroundColor: "primary.main",
                  borderRadius: "50%",
                  animation: "bounce 1.2s infinite ease-in-out",
                  animationDelay: "0.4s",
                }}
              />
            </Box>
          </Box>
        )}
      </Drawer>
    </>
  );
};

export default ChatFeedbackPageDrawer;
